// extracted by mini-css-extract-plugin
module.exports = {"root":"faq_root__2DALG","inner":"faq_inner__1XxAE","items":"faq_items__32bvz"};